import { Action, createReducer, on } from '@ngrx/store';
import { IPreviousSelfieResponse } from '../models/selfie.model';
import { fromSelfieActions } from '../actions';

export const archivedSelfieFeatureKey = 'archivedSelfie';

export interface ArchivedSelfieState {
  loadArchivedSelfie: string;
  loadArchivedSelfieSuccess: IPreviousSelfieResponse[];
  loadArchivedSelfieFailure: Error | any;
}

export const initialState: ArchivedSelfieState = {
  loadArchivedSelfie: undefined,
  loadArchivedSelfieSuccess: undefined,
  loadArchivedSelfieFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromSelfieActions.loadPreviousSelfieRequest, (state, action) => ({
    ...state,
    loadArchivedSelfie: action.request
  })),
  on(fromSelfieActions.loadPreviousSelfieResponse, (state, action) => ({
    ...state,
    loadArchivedSelfieSuccess: action.response
  })),
  on(fromSelfieActions.loadPreviousSelfieFailure, (state, action) => ({
    ...state,
    loadArchivedSelfieFailure: action.error
  }))
);

export const getPreviousSelfies = (state: ArchivedSelfieState) => state.loadArchivedSelfieSuccess;
